import {
  CancelOrderRequest,
  GetInfoForBookingRequest,
  GetOrderByOrderNumberRequest,
  OrderInfoDto,
  PreorderBookingDetailsInfoResponseDto,
  SubmitOrderBookingInfoRequestDto,
  SubmitPersonalInfoRequest,
  SubmitPersonalInfoResponseDto,
} from '@/api/generated/fetch-client';
import { RepositoryException, WithSignal } from '@/types/typings';

import { OrderApi } from '../api';

export class OrderRepository {
  constructor(private readonly orderApi: OrderApi) {}

  public async getInfoForBooking(
    requestParameters: WithSignal<GetInfoForBookingRequest>,
  ): Promise<PreorderBookingDetailsInfoResponseDto> {
    const preorder = await this.orderApi.getInfoForBooking(requestParameters);

    if (!preorder) {
      throw new RepositoryException('repository getInfoForBooking error');
    }

    return preorder;
  }

  public async submitBookingInfo(
    requestParameters: SubmitOrderBookingInfoRequestDto,
  ): Promise<object> {
    const response = await this.orderApi.submitBookingInfo({
      submitOrderBookingInfoRequestDto: requestParameters,
    });

    if (!response) {
      throw new RepositoryException('repository submitBookingInfo error');
    }

    return response;
  }

  public async submitPersonalInfo(
    requestParameters: WithSignal<SubmitPersonalInfoRequest>,
  ): Promise<SubmitPersonalInfoResponseDto> {
    const response = await this.orderApi.submitPersonalInfo(requestParameters);

    if (!response) {
      throw new RepositoryException('repository submitPersonalInfo error');
    }

    return response;
  }

  public async getOrderInfoByOrderNumber(
    requestParameters: WithSignal<GetOrderByOrderNumberRequest>,
  ): Promise<OrderInfoDto> {
    const response = await this.orderApi.getOrderInfoByOrderNumber(requestParameters);

    if (!response) {
      throw new RepositoryException('repository getOrderInfoByOrderNumber error');
    }

    return response;
  }

  public async checkOrderExistsByOrderNumber(
    requestParameters: GetOrderByOrderNumberRequest,
  ): Promise<OrderInfoDto> {
    return await this.orderApi.checkOrderExistsByOrderNumber(requestParameters);
  }

  public async cancelOrder(requestParameters: CancelOrderRequest) {
    return await this.orderApi.cancelOrder(requestParameters);
  }
}
